import moment from 'moment';
import 'moment/locale/fr';
import Countries from './Countries';
import { CsI18n } from './shared/csI18n/csI18n';

class Replacement {
  static CURRENT_DATE = 'currentDate';

  static getRuntimeMentions = () => {
    return [
      { id: `{{runtime:${this.CURRENT_DATE}}}`, desc: 'Current date' },
    ];
  };

  conditionValues = {};
  variableValues = {};
  lang = 'en';
  log = () => {
  };

  _content = '';

  constructor (content, conditionValues, variableValues, lang, debugHandler = null) {
    this._content = content;
    this.conditionValues = { ...conditionValues };
    this.variableValues = { ...variableValues };
    if (lang) {
      // todo: Check valid lang?
      this.lang = lang;
    }
    if (debugHandler) {
      this.log = debugHandler;
    }
  }

  getContent = () => {
    return this._content;
  };

  replace = () => {
    this.replaceConditionTags();
    this.replaceVariables();
  };

  replaceConditionTags = () => {
    let wrapper = document.createElement('div');

    wrapper.innerHTML = this._content;
    wrapper = this._replaceConditionTagType(wrapper, true);
    wrapper = this._replaceConditionTagType(wrapper, false);
    // this.log('Replacement - Condition', 'After replacement', this._content);

    this._content = wrapper.innerHTML;
  };

  replaceVariables = () => {
    let wrapper = document.createElement('div');
    wrapper.innerHTML = this._content;
    // Conditional tag are handled, so it's safe to process all the patterns
    const variables = wrapper.querySelectorAll('span.mention[data-mention^="{{"][data-mention$="}}"]');

    for (const variable of variables) {
      const mention = variable.dataset['mention'],
        mentionStr = mention.substring(2, mention.length - 2),
        mentionSegment = mentionStr.split(':');
      if (mentionSegment.length === 2) {
        const category = mentionSegment.shift(), key = mentionSegment.pop();
        let theReplacement, replaceAsHtml = false;
        if (category === 'runtime') {
          theReplacement = this.replaceRuntimeVariables(key).toString();
        } else {
          const replacement = this.variableValues?.[mentionStr] ?? null,
            rt = replacement?.['t'] ?? null, rv = replacement?.['v'] ?? null;
          if (replacement && rt && rv) {
            if (rt === 'nc') {
              const country = Countries.find(country => country.key === rv);
              if (country) {
                theReplacement = country.label;
              } else {
                // Country not found
                theReplacement = '';
                this.log('Replacement - Variable', 'Country not found', rv);
              }
            } else if (rt === 'sccr' && rv.length) {
              // Need to translate all components of this type
              theReplacement = rv.map(component => CsI18n.t(component)).join(', ');
            } else if (rt === 'dt' && replacement?.['format']) {
              theReplacement = moment(rv, replacement['format']).locale(this.lang).format('L');
            } else if (['hr', 'tr'].includes(rt)) {
              theReplacement = CsI18n.t(rv);
            } else {
              theReplacement = rv.toString();
              if (rt === 's1') {
                theReplacement = CsI18n.t(theReplacement);
              } else if (rt === 'tb') {
                replaceAsHtml = true;
              }
            }
          } else {
            // Unrecognized variable
            this.log('Replacement - Variable', 'Unrecognized variable', mentionStr);
          }
        }

        if (typeof theReplacement === 'undefined') {
          // Replacement not found or missing
          // Some mentions has it own missing warning
          if (['company:mediationServiceName', 'company:mediationUrl'].includes(mentionStr)) {
            theReplacement = CsI18n.t('To be completed at our mediation service');
          } else {
            theReplacement = CsI18n.t('To be completed') + ` [${key}]`;
          }
          replaceAsHtml = false;
          variable.classList.add('undefined');
        }

        if (replaceAsHtml) {
          variable.innerHTML = theReplacement;
        } else {
          variable.textContent = theReplacement;
        }
      } else {
        // Malformed variable
        this.log('Replacement - Variable', 'Malformed variable', mentionStr);
      }
    }

    this._content = wrapper.innerHTML;
  };

  _replaceConditionTagType (wrapper, isBlock) {
    const startConditions = isBlock ?
      wrapper.querySelectorAll('span.mention_condition_block[data-mention^="{{if:"][data-mention$="}}"]') :
      wrapper.querySelectorAll('span.mention[data-mention^="{{if:"][data-mention$="}}"]');

    for (const startCondition of startConditions) {
      // Find mention key
      const mention = startCondition.dataset['mention'],
        mentionStr = mention.substring(2, mention.length - 2),
        mentionSegment = mentionStr.split(':');
      if (mentionSegment.length === 2) {
        const mentionKey = mentionSegment[1];
        // End condition is after start condition
        const endCondition = isBlock ?
          wrapper.querySelector(`span.mention_condition_block[data-mention="{{endif:${mentionKey}}}"]`) :
          wrapper.querySelector(`span.mention[data-mention="{{endif:${mentionKey}}}"]`);

        if (endCondition) {
          // Block condition is nested inside a <p>, we process that <p> instead
          const removeNodes = isBlock ?
            this._replaceConditionTagCollectRemoveNodes(startCondition.parentNode, endCondition.parentNode, mentionKey) :
            this._replaceConditionTagCollectRemoveNodes(startCondition, endCondition, mentionKey);
          removeNodes.map(removeNode => removeNode.remove());
        } else {
          // End tag not exist
          this.log('Replacement - Condition', 'End condition tag not exist', mentionKey);
        }

      } else {
        // Malformed condition
        this.log('Replacement - Condition', 'Malformed condition', mentionStr);
      }
    }

    return wrapper;
  }

  _replaceConditionTagCollectRemoveNodes (startCondition, endCondition, mentionKey) {
    let removeNodes = [];

    if (startCondition.compareDocumentPosition(endCondition) & Node.DOCUMENT_POSITION_FOLLOWING) {
      // console.log('-debug', mentionKey, conditionValues.hasOwnProperty(mentionKey), conditionValues[mentionKey]);
      if (this.conditionValues.hasOwnProperty(mentionKey)) {
        if (!this.conditionValues[mentionKey]) {
          // If condition does not exist, leave it as is
          // If condition exist and false, remove nodes from dom.
          let node = startCondition;
          removeNodes.push(node);
          while (node.nextSibling && node.nextSibling !== endCondition) {
            node = node.nextSibling;
            removeNodes.push(node);
          }
          removeNodes.push(endCondition);
          // Remove those nodes
          // for (const removeNode of removeNodes) {
          //   removeNode.remove();
          // }
        } else {
          // Condition value is true, do nothing
          this.log('Replacement - Condition', 'Condition value == true, only remove start & end tag', mentionKey);
          removeNodes.push(startCondition, endCondition);
          // startCondition.remove();
          // endCondition.remove();
        }
      } else {
        // Condition value not exist
        this.log('Replacement - Condition', 'Condition value does not exist', mentionKey);
      }
    } else {
      // End tag is not after start tag
      this.log('Replacement - Condition', 'End condition tag is not after start condition', mentionKey);
    }

    return removeNodes;
  }

  replaceRuntimeVariables = key => {
    switch (key) {
      case Replacement.CURRENT_DATE:
        return moment().locale(this.lang).format('L');
      default:
        return '';
    }
  };
}

export default Replacement;
